module.exports = __webpack_public_path__ + "img/google-play-badge-no.32c140ad.png";